import { render, staticRenderFns } from "./ContactsListView.vue?vue&type=template&id=11a45212&"
import script from "./ContactsListView.vue?vue&type=script&lang=js&"
export * from "./ContactsListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports